import React, { useState } from 'react';
import { useLayout } from '../../../context/LayoutContext';
import '../../../assets/scss/components/wssp/MessageInput.scss';
import { useWhatsApp } from '../../../context/WhatsAppContext';

const MessageInput = () => {
  const { theme } = useLayout();
  const { selectedChat, sendMessage, connected } = useWhatsApp();
  const [text, setText] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  
  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (text.trim() && selectedChat && connected && !isSubmitting) {
      setIsSubmitting(true);
      sendMessage(text);
      setText('');
      setTimeout(() => setIsSubmitting(false), 500);
    }
  };
  
  if (!selectedChat) return null;
  
  return (
    <div className={`GM__${theme}-wssp-message-input`}>
      <form onSubmit={handleSubmit}>
        <div className={`GM__${theme}-wssp-input-container`}>
          <button 
            type="button" 
            className={`GM__${theme}-wssp-action-button`} 
            title="Insertar emoji"
          >
            😊
          </button>
          <button 
            type="button" 
            className={`GM__${theme}-wssp-action-button`} 
            title="Adjuntar archivo"
          >
            📎
          </button>
          <input
            type="text"
            placeholder="Escribe un mensaje"
            value={text}
            onChange={e => setText(e.target.value)}
            disabled={!connected}
            className={`GM__${theme}-wssp-text-input ${!connected ? 'disabled' : ''}`}
          />
          <button 
            type="submit" 
            className={`GM__${theme}-wssp-send-button ${(!text.trim() || !connected || isSubmitting) ? 'disabled' : ''}`} 
            disabled={!text.trim() || !connected || isSubmitting}
            title="Enviar mensaje"
          >
            📤
          </button>
        </div>
      </form>
      {!connected && (
        <div className={`GM__${theme}-wssp-connection-warning`}>
          Sin conexión. Espera mientras reconectamos...
        </div>
      )}
    </div>
  );
};

export default MessageInput;